import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSerializer } from '@angular/router';

import { LocaleUrlSerializer } from './_shared/locale/locale-url.serializer';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  // Wariant B-full (DESIGN §2.1). Ta trasa istnieje po to, zeby BUILD-TIME route extraction
  // @angular/ssr wpisal `/en` i `/en/**` do manifestu (dist/.../angular-app-manifest.mjs) —
  // bez wpisu w KLIENCKIEJ tablicy tras zadanie na /en/** dostaje 302 -> /404 PRZED bootstrapem
  // (ssr.mjs:1171-1191) i nigdy nie dociera do Angulara. Dopisanie `en/**` do app.routes.server.ts
  // jest no-opem (ssr.mjs:805-812) — zludzenie ochrony, nie obrona.
  // 🔴 W RUNTIME ta trasa NIE jest martwa (wczesniejszy komentarz twierdzil inaczej —
  // to bylo zalozenie podane jako fakt). LocaleUrlSerializer.parse() stoi tylko na drodze
  // nawigacji zaczynajacej sie od STRINGA (adres z paska, navigateByUrl, routerLink="/en/x")
  // — tam prefiks faktycznie znika i dopasowuje sie wezel `path: ''`. Omijaja parse():
  //   - router.navigate(['/en', 'menu']) — UrlTree budowany z segmentow, serializera brak
  //     na tej sciezce (locale-route-live.spec.ts),
  //   - adresy, ktorych stringowy parser nie uznaje za prefiks, np. '/en;x=1/menu'
  //     (zmierzone: 200 z trescia /menu na tej galezi, 302 -> /404 na develop).
  // W obu przypadkach MainModule laduje sie przez DRUGI wpis loadChildren (wlasny injector
  // modulu). Dopoki nikt nie pisze '/en' recznie w nawigacji, jest to niewidoczne —
  // ale to wlasnosc dyscypliny w kodzie, nie gwarancja routera.
  // H2: `admin` NIE jest dzieckiem tego pod-drzewa (jest rodzenstwem, wyzej), wiec /en/admin/**
  // laduje na `/en/**` -> `/en/404` — panel nie renderuje sie na SSR, niezaleznie od flagi.
  {
    path: 'en',
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
  },
  // 🔴 `/pl/**` MUSI byc osobnym wpisem KLIENCKIM z dokladnie tego samego powodu co `en`
  // (decyzja produktowa: polski ma sie serwowac ZAROWNO pod `/...`, JAK I pod `/pl/...`).
  // Zmierzone na zbudowanym artefakcie PRZED ta zmiana: `/pl`, `/pl/` i `/pl/menu`
  // dostawaly 302 -> /404, mimo ze splitLocalePrefix od zawsze rozpoznaje segment 'pl'
  // i mimo `path: '**'` w app.routes.server.ts. Powod: @angular/ssr dopasowuje adres do
  // manifestu tras wyekstrahowanych z KLIENCKIEJ tablicy i odrzuca zadanie PRZED
  // bootstrapem (ssr.mjs:1171-1191) — wiec ani serializer, ani APP_INITIALIZER locale,
  // ani serverRoutes nie zdazylyby sie wykonac. Dopisanie 'pl/**' do app.routes.server.ts
  // bylo by no-opem (ssr.mjs:805-812), tak samo jak bylo dla 'en/**'.
  //
  // Dlaczego to NIE powoduje 302 na siebie samego (wlasnosc 1 z locale-url.serializer.ts):
  // dla polskiego `splitLocalePrefix('/pl/menu').prefix` to '' (H6 — PL nie ma prefiksu
  // KANONICZNEGO), wiec engine porownuje serializacje adresu zadania i adresu koncowego —
  // obie przechodza przez ten sam serializer i obie daja '/menu'. Rowne stringi = brak
  // redirectu, render 200 pod adresem z prefiksem. To takze powod, dla ktorego linki
  // wewnetrzne dalej wychodza BEZ '/pl' — i dlaczego canonical (z data.seo) wskazuje
  // wersje bezprefiksowa, czyli nie powstaje duplicate content.
  {
    path: 'pl',
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
  },
  {
    path: '',
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'top',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
  // Serializer musi byc dostepny ZANIM zadziala initialNavigation: 'enabledBlocking' powyzej.
  providers: [{ provide: UrlSerializer, useClass: LocaleUrlSerializer }],
})
export class AppRoutingModule {}
